import React, { useState, useEffect } from 'react';
import {
  Box
} from '@mui/material';
import Config from './config/Config';
import AppleSpinner from '../common/AppleSpinner';
import PatientView from './patients/Patients';

const AGTHealth = ({ user, onUpdateUser }) => {
  const [configuredUser, setConfiguredUser] = useState(null);
  const [showConfig, setShowConfig] = useState(false);
  const [loading, setLoading] = useState(true);

  // Initialize user from props or localStorage
  useEffect(() => {
    const loadUserFromStorage = () => {
      const userType = localStorage.getItem('healthUserType');
      const country = localStorage.getItem('healthUserCountry');
      const userId = localStorage.getItem('healthUserId');
      const providerType = localStorage.getItem('healthProviderType');
      const providerName = localStorage.getItem('healthProviderName');
      const providerId = localStorage.getItem('healthProviderId');
      const hasRegisteredRecord = localStorage.getItem('healthHasRecord');
      const healthCenter = localStorage.getItem('healthCenter') || providerName;

      if (userType && country && userId && healthCenter) {
        return {
          userType,
          country,
          userId,
          healthCenter,
          providerType,
          providerName,
          providerId,
          hasRegisteredRecord: hasRegisteredRecord === 'true'
        };
      }
      return null;
    };

    const initUser = user || loadUserFromStorage();
    setConfiguredUser(initUser);
    setShowConfig(!initUser || !initUser.userType);
    setLoading(false);
  }, [user]);

  // Handle user type update from Config component
  const handleUserTypeUpdate = (updatedUser) => {
    setConfiguredUser(updatedUser);
    setShowConfig(false);

    if (onUpdateUser) {
      onUpdateUser(updatedUser);
    }
  };

  // Loading state
  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}>
        <AppleSpinner sizeDesktop={60} sizeMobile={40} />
      </Box>
    );
  }

  // Main container with proper scrolling
  return (
    <Box sx={{ 
      width: '100%',
      height: '100%', // Fill the available height
      position: 'relative', // For positioning context
      overflow: 'auto', // Enable scrolling on the main container
    }}>
      <Box sx={{
        width: '100%',
        // Add padding at the bottom to create space for the "footer"
        pb: { xs: '80px', sm: '100px', md: '120px' },
      }}>
        {showConfig ? (
          <Config 
            onUpdateUser={handleUserTypeUpdate} 
            currentUser={configuredUser} 
          />
        ) : (
          <PatientView user={configuredUser} />
        )}
      </Box>
    </Box>
  );
};

export default AGTHealth;
